import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type ConditionsEducationalModalContextValue = {
  reviewOpen: boolean;
  reviewNonce: number;
  openReview: () => void;
  closeReview: () => void;
};

const noop = () => {};

const ConditionsEducationalModalContext =
  createContext<ConditionsEducationalModalContextValue>({
    reviewOpen: false,
    reviewNonce: 0,
    openReview: noop,
    closeReview: noop,
  });

export function ConditionsEducationalModalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [reviewOpen, setReviewOpen] = useState(false);
  // Bumped on every open so the modal remounts and starts from the first slide.
  const [reviewNonce, setReviewNonce] = useState(0);

  const openReview = useCallback(() => {
    setReviewNonce(prev => prev + 1);
    setReviewOpen(true);
  }, []);

  const closeReview = useCallback(() => setReviewOpen(false), []);

  const value = useMemo(
    () => ({ reviewOpen, reviewNonce, openReview, closeReview }),
    [reviewOpen, reviewNonce, openReview, closeReview],
  );

  return (
    <ConditionsEducationalModalContext.Provider value={value}>
      {children}
    </ConditionsEducationalModalContext.Provider>
  );
}

export function useConditionsEducationalModal() {
  return useContext(ConditionsEducationalModalContext);
}
